export default "__VITE_ASSET__CwsH9GgX__"